export default "/images/vendor/flag-icon-css/flags/1x1/mx.svg?05c8d69783e68aaad2f439631db79616";